export function getCookie(name: string): string | null {
	return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() ?? null
}
